import { componentProvider } from 'js-component-framework/es';

/**
 * Handle applied filters.
 *
 * @param {HTMLFormElement} args.element  The filters form.
 * @param {array}           args.children The filters form child elements.
 */
function filterCounter({ element, children }) {
  const { resetButtons } = children;
  const { filterCount = 0 } = window?.hbg2023?.searchFilters;

  /**
   * The HTMLFormControlsCollection value transformed into an array.
   *
   * @type {array}
   */
  const formChildren = Array.from(element.elements);

  // Gather search params.
  const searchResultsUrl = new URL(document.location);
  const { searchParams: searchResultsParams } = searchResultsUrl;

  /**
   * Updates button enabled state when form elements are checked.
   *
   * @param {boolean} enabled Whether the buttons should be enabled.
   */
  const updateButtonEnabledState = (enabled) => {
    if (enabled) {
      resetButtons.forEach((button) => button.removeAttribute('aria-disabled'));
    } else {
      resetButtons.forEach((button) => button.setAttribute('aria-disabled', 'true'));
    }
  };

  /**
   * Update reset button enabled state as form elements are changed.
   */
  const handleFormChange = () => {
    // Find any checked input that are not the default `sortby` or `content_type` values.
    const checkedInput = formChildren.find((input) => (
      'relevancy' !== input.value && input.checked
      || 'hbg-title' !== input.value && input.checked
    ));

    updateButtonEnabledState(undefined !== checkedInput);
  };

  /**
   * Reset the form.
   *
   * If any filters are applied to the results, we clear them by re-submitting
   * the original query with no filters applied. Otherwise we allow the reset to
   * proceed after disabling the reset buttons.
   */
  const handleReset = () => {
    if (0 < filterCount) {
      const newUrl = new URL(searchResultsUrl.origin);
      newUrl.searchParams.set('s', searchResultsParams.get('s'));
      document.location = newUrl;
    } else {
      updateButtonEnabledState(false);
    }
  };

  element.addEventListener('change', handleFormChange);
  element.addEventListener('reset', handleReset);
}

/**
 * Search results filter counter.
 */
const filterCounterConfig = {
  name: 'filter-counter',
  component: filterCounter,
  querySelectorAll: {
    resetButtons: 'button[type=reset]',
  },
};

// Load components.
componentProvider(filterCounterConfig);
